import React, { useContext } from "react";
import { mapEdgesToNodes } from "../../../lib/helpers";
import { graphql, useStaticQuery } from "gatsby";
import { CardGrid } from "../../card/card-grid";
import { SiteContext } from "../../global/site-context";

const query = graphql`
  query BlogListQuery {
    posts: allSanityPost(
      limit: 30
      sort: { fields: [publishedAt], order: DESC }
      filter: { slug: { current: { ne: null } }, status: { eq: "published" } }
    ) {
      edges {
        node {
          ...cardNode
        }
      }
    }
    stories: allSanityStory(
      limit: 4
      sort: { fields: [publishedAt], order: DESC }
      filter: { slug: { current: { ne: null } }, status: { eq: "published" } }
    ) {
      edges {
        node {
          ...cardNodeStory
        }
      }
    }
  }
`;

const EXCLUDED_TAG = "973d1158-d9cf-46c9-8b1e-d997403fde9f";

const excludeTagged = (nodes) =>
  nodes &&
  nodes.filter(
    (node) => !node.categories || !node.categories.find((cat) => cat._id === EXCLUDED_TAG)
  );

export const BlogList = () => {
  const site = useContext(SiteContext);
  const data = useStaticQuery(query) || {};
  const posts = excludeTagged(data?.posts && mapEdgesToNodes(data.posts))?.slice(0, 24);
  const stories = excludeTagged(data?.stories && mapEdgesToNodes(data.stories));

  return (
    <CardGrid
      maxColumns={1}
      nodes={
        site.isActive("storiesInBlog")
          ? posts
            .concat(stories)
            .sort((a, b) => (a.publishedAt < b.publishedAt ? 1 : -1))
          : posts
      }
      browseMoreHref="/resources/blog/"
      hideType={true}
      showSubTags={true}
      showAllImages={true}
    />
  );
};
